import React from "react";
export default function NPV() {
  return <div>Excel_NPV</div>;
}
